import { Box, Skeleton } from '@mui/material';

import SubscriptionStatus from './StatusSubscription';

import { StatusSchema } from '../types';

import * as S from '../styles';

interface SubscriptionStatusProps {
  statusSchema: StatusSchema;
  expiredAt: string | undefined;
  patientSubscriptionLoading: boolean;
}

export const RenderSubscriptionInfo = ({
  statusSchema,
  expiredAt,
  patientSubscriptionLoading,
}: SubscriptionStatusProps) => {
  if (patientSubscriptionLoading) {
    return (
      <S.BigNumbers>
        <Skeleton variant="rectangular" width="100px" height="40px" />
        <Box mt={1}>
          <Skeleton variant="rectangular" width="150px" height="24px" />
        </Box>
      </S.BigNumbers>
    );
  }

  return (
    <SubscriptionStatus statusSchema={statusSchema} expiredAt={expiredAt} />
  );
};
